import React from "react";
import { Drawer } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import Tooltip from "@mui/material/Tooltip";
import { formatDateReadable, getInitials } from "../../utilities/helpers";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import TradeTargetSelectModal from "./TradeTargetSelectModal";
import ShiftDropAddNoteModal from "./ShiftDropAddNoteModal";
import DrawerHeader from "../helpers/DrawerHeader";
import DrawerFooterContainerLarge from "../helpers/DrawerFooterContainerLarge";
import ButtonFilled from "../helpers/ButtonFilled";
import ButtonGrayed from "../helpers/ButtonGrayed";
import ModalUserStatusCard from "../helpers/ModalUserStatusCard";
import ModalInfoCard from "../helpers/ModalInfoCard";
import ModalInfoCardAlsoWorking from "../helpers/ModalInfoCardAlsoWorking";
import {
  CalendarToday,
  Description,
  ChatBubbleOutline,
  Send,
  Edit,
  AccessTime,
  WorkOutline,
  Pause,
  PlaceOutlined,
  Groups,
  BackHandOutlined,
} from '@mui/icons-material';
import DrawerFooterContainerSmall from "../helpers/DrawerFooterContainerSmall";

function ShiftDropDrawer(props) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  function handleRescindDropShift() {
    props.rescind_drop_shift(props.shiftInfo.id);
  }

  function handleRescindTradeShift() {
    props.rescind_trade_shift(props.shiftInfo.id);
  }

  const [openAddDropNoteModal, setOpenAddDropNoteModal] = React.useState(false);
  const handleOpenAddDropNoteModal = () => setOpenAddDropNoteModal(true);
  const handleCloseAddDropNoteModal = () => setOpenAddDropNoteModal(false);

  return (
    <Drawer anchor="right" open={props.open} onClose={props.onClose}>
      <div className="w-[450px] h-full bg-white relative">
        <div className="max-h-screen overflow-auto">
          <DrawerHeader title="Selected Shift" onClose={props.onClose} />
          <div>
            <div className="mb-6 px-6">
              <ModalUserStatusCard
                name={`${props.firstName} ${props.lastName}`}
                initials={getInitials(props.firstName, props.lastName)}
                backgroundColor={props.shiftCardColor}
              />
            </div>

            <div className="w-full my-6 px-6">
              {props.badgeText && (
                <div className="flex flex-row items-center justify-between bg-amber-50 border border-amber-200 px-4 py-3 rounded-xl">
                  <div className="flex flex-row items-center space-x-2 text-amber-700">
                    <WarningAmberIcon sx={{ fontSize: 20 }} />
                    <p className="text-amber-700 text-sm">
                      {props.badgeText}
                    </p>
                  </div>
                  {props.badgeText !== "Your Shift" && (
                    <div
                      className="px-3 py-1.5 bg-amber-600 hover:bg-amber-700 rounded-lg cursor-pointer transition-colors"
                      onClick={
                        props.badgeText === "Drop Requested" ||
                        props.badgeText === "Add to Pool Requested"
                          ? () => handleRescindDropShift()
                          : () => handleRescindTradeShift()
                      }
                    >
                      <p className="text-white text-sm">Cancel</p>
                    </div>
                  )}
                </div>
              )}
            </div>

            <div className="w-full px-6">

              <div className="mb-4 flex items-center space-x-4">
                <div className="flex-1">
                  <ModalInfoCard
                    icon={CalendarToday}
                    title="Date"
                    value={formatDateReadable(props.date)}
                  />
                </div>
                <div className="flex-1">
                  <ModalInfoCard
                    icon={AccessTime}
                    title="Time"
                    value={props.shiftInfo?.shift}
                  />
                </div>
              </div>

              <div className="mb-4 flex items-center space-x-4">
                <div className="flex-1">
                  <ModalInfoCard
                    icon={Pause}
                    title="Meal break"
                    value={props.break}
                  />
                </div>
                <div className="flex-1">
                  <ModalInfoCard
                    icon={WorkOutline}
                    title="Role"
                    value={props.station
                      ? props.station
                      : props.role
                      ? props.role
                      : props.roleType}
                  />
                </div>
              </div>
              {props.shiftInfo?.paid_break_summary && (
                <div className="mb-4 flex items-center space-x-4">
                  <div className="flex-1">
                    <ModalInfoCard
                      icon={BackHandOutlined}
                      title="Paid breaks"
                      value={props.shiftInfo.paid_break_summary}
                    />
                  </div>
                </div>
              )}

              {props.note &&
                <div className="mb-4">
                  <ModalInfoCard
                    icon={ChatBubbleOutline}
                    title="Shift Note"
                    value={props.note}
                  />
                </div>
              }

              {props.location && (
                <div className="mb-4">
                  <ModalInfoCard
                    icon={PlaceOutlined}
                    title="Location"
                    value={props.location}
                  />
                </div>
              )}

            {props.alsoWorking && props.alsoWorking?.length > 0 &&
              <div className="mb-4">
                <ModalInfoCardAlsoWorking
                  icon={Groups}
                  title="Teammates"
                  alsoWorking={props.alsoWorking}
                  roleNames={props.roleNames}
                />
              </div>
            }

            </div>

          </div>
          <DrawerFooterContainerSmall>
            {!props.badgeText && !props.isDateInPast ? (
              <div className="w-full flex flex-row items-center">
                <div className="w-1/2 pr-2">
                  <ButtonFilled text="Trade" onClick={handleOpen} />
                </div>
                <div className="w-1/2 pl-2">
                  <ButtonFilled
                    text="Drop"
                    // onClick={props.handleAddToPoolPress}
                    onClick={handleOpenAddDropNoteModal}
                  />
                </div>
              </div>
            ) : (
              <div className="w-full flex flex-row items-center">
                <div className="w-1/2 pr-2">
                  <ButtonGrayed text="Trade" />
                </div>
                <div className="w-1/2 pl-2">
                  <ButtonGrayed text="Drop" />
                </div>
              </div>
            )}
          </DrawerFooterContainerSmall>
          <div className="h-[210px]"></div>
        </div>
      </div>
      <ShiftDropAddNoteModal
        open={openAddDropNoteModal}
        handleClose={handleCloseAddDropNoteModal}
        handleAddToPoolPress={props.handleAddToPoolPress}
      />
      <TradeTargetSelectModal
        open={open}
        handleClose={handleClose}
        drop_shift={props.drop_shift}
        trade_shift={props.trade_shift}
        shiftInfo={props.shiftInfo}
        notMyUpcomingShifts={props.notMyUpcomingShifts}
        roleNames={props.roleNames}
      />
    </Drawer>
  );
}

export default ShiftDropDrawer;
